document.addEventListener("DOMContentLoaded", function() {
	const config = {
	  type: "carousel",
	  perView: 1,
	  startAt: 0,
	  perTouch: 1,
	};
    if($('.example.glide')[0]) {
		var options = new Glide(".example.glide", config)
		options.mount();
	};
});


jQuery(document).ready(function($){

	$('.accordionTitle').click(function(e) {
		$( this ).parent().toggleClass('active');
	});

	$('.home-modal-inner button').click(function() {
		$('.home-modal').hide();
		$('body').css('overflow', 'scroll');
	});

	$('nav#site-navigation > button').click(function(e) {
		$( this ).parent().toggleClass('toggled');
		$( 'header' ).parent().toggleClass('toggledMainMenu');
	});
	$('.closeMenu').click(function(e) {
  		e.preventDefault();
		$('.toggled').toggleClass('toggled');
		$('.toggledMainMenu').toggleClass('toggledMainMenu');
	});

	$('.plusMinus').click(function(e) {
		$( this ).parent().toggleClass('activeMenu');
	});


	$('.scroll-to-href').click(function(e) {
		var elementToScroll = jQuery(this).attr('href');
		console.log(elementToScroll);
	    $([document.documentElement, document.body]).animate({
	        scrollTop: $(elementToScroll).offset().top-20
	    }, 1000);
	});

});
